import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { dispatch, select, useSelect } from '@wordpress/data';
import {PanelBody, __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption} from '@wordpress/components';
import {HorizontalLeft,HorizontalRight,HorizontalTop,HorizontalBottom} from '../../../../../src/helpers/icon.js';
import {VayuBlocksToggleControl,VayuBlocksSelectControl,GroupControl,HeightControl} from '@vayu-blocks';

const SlideSettings = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const selectedBlock = useSelect((select) => {return select('core/block-editor').getSelectedBlock();});

    const [blockValue, setBlockValue] = useState('flip');

    // Handle toggle change event
    const handleToggleChange = (value) => {
        setBlockValue(value);

        // Check if a block is selected
        if (selectedBlock) {
            // Get all inner blocks of the selected block
            const innerBlocks = select('core/block-editor').getBlocks(selectedBlock.clientId);

            // Select the appropriate inner block based on the toggle value
            if (value === 'front') {
                // Assuming the first inner block is for the front
                const frontBlock = innerBlocks[0]; 
                if (frontBlock) {
                    dispatch('core/block-editor').selectBlock(frontBlock.clientId);
                }
            } else if (value === 'back') {
                // Assuming the second inner block is for the back
                const backBlock = innerBlocks[1]; 
                if (backBlock) {
                    dispatch('core/block-editor').selectBlock(backBlock.clientId);
                }
            }
        }
    };
    
    return (
        <>
            <div className="vayu_blcoks_togglecontrol">
                <ToggleGroupControl
                    value={blockValue}
                    isBlock
                    __nextHasNoMarginBottom={true}
                    __next40pxDefaultSize={true}
                    onChange={handleToggleChange}
                >
                    <ToggleGroupControlOption value="front" label="Front" />
                    <ToggleGroupControlOption value="flip" label="Flip Box" />
                    <ToggleGroupControlOption value="back" label="Back" />
                </ToggleGroupControl>
            </div>

            <div className="vayu_blocks_image-flip-settings_main">
                {/* Overlay and animation effect  */}
                <PanelBody 
                    title={__('Advance Hover Animation','vayu-blocks')} 
                    opened={openPanels['slide-image']}
                    onToggle={() => onTogglePanel('slide-image')} 
                >
                    <VayuBlocksSelectControl
                        label={__('Image Effect', 'vayu-blocks')}
                        value={attributes.imagehvreffect}
                        options={[
                                { label: __('None', 'vayu-blocks'), value: 'none' },
                                { label: __('Flip', 'vayu-blocks'), value: 'flip' },
                                { label: __('Slide', 'vayu-blocks'), value: 'slide' },
                                { label: __('Push', 'vayu-blocks'), value: 'push' },
                                { label: __('Flip Left Top', 'vayu-blocks'), value: 'flip-z' },
                                { label: __('Flip Right Top', 'vayu-blocks'), value: 'flip-x' },
                                { label: __('Zoom in', 'vayu-blocks'), value: 'zoom-in' },
                                { label: __('Zoom out', 'vayu-blocks'), value: 'zoom-out' },
                                { label: __('Fade In', 'vayu-blocks'), value: 'fade-in' },
                        ]}
                        onChange={(value) => setAttributes({ imagehvreffect: value })}
                    />

                    { (attributes.imagehvreffect==='flip' || attributes.imagehvreffect==='slide' || attributes.imagehvreffect==='push') && (
                        <>
                            <GroupControl
                                label={__('Flip Side', 'vayu-blocks')}
                                value={ attributes.flipside}
                                onChange={(value) => setAttributes({flipside:value})}
                                options={[
                                    {
                                        icon: HorizontalLeft,
                                        label: __( 'Left', 'vayu-blocks' ),
                                        value: 'left'
                                    },
                                    {
                                        icon: HorizontalRight,
                                        label: __( 'Right', 'vayu-blocks' ),
                                        value: 'right'
                                    },
                                    {
                                        icon: HorizontalTop,
                                        label: __( 'Start', 'vayu-blocks' ),
                                        value: 'top'
                                    },
                                    {
                                        icon: HorizontalBottom,
                                        label: __( 'End', 'vayu-blocks' ),
                                        value: 'bottom'
                                    },
                                ]}
                                
                                hasIcon = {true}
                            />
                            <br/>
                        </>
                    )}
                    
                    {attributes.imagehvreffect && !(attributes.imagehvreffect === 'zoom-in' || attributes.imagehvreffect === 'zoom-out' || attributes.imagehvreffect === 'fade-in'|| attributes.imagehvreffect === 'slide'|| attributes.imagehvreffect === 'push') && (
                        <VayuBlocksToggleControl
                            label={__('3D Box animation', 'vayu-blocks')}
                            checked={attributes.dbox}
                            onChange={(value) =>  setAttributes({dbox:value})}
                        />
                    )}
                </PanelBody>
                
            </div>

            <PanelBody title={__('Height','vayu-blocks')} opened={openPanels['slide-height']}
        onToggle={() => onTogglePanel('slide-height')} >
                <HeightControl 
                    label={__('Height', 'vayu-blocks')}
                    onChange={(val) => setAttributes({advheight:val})}
                    value={attributes.advheight}
                    responsive= {true}
                />
            </PanelBody>
        </>
    );
};

export default SlideSettings;
